module.exports = __webpack_public_path__ + "img/achievementIcon.eafe4b75.png";